import gql from 'graphql-tag';

const UPLOAD_SINGLE_SIM = gql`
  mutation Mutation($simNumber: String!, $networkProvider: String!, $isActive: Boolean!) {
    uploadSingleSim(simNumber: $simNumber, networkProvider: $networkProvider, isActive: $isActive) {
      code
    }
  }
`;

export default UPLOAD_SINGLE_SIM;
